import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { EllipsisPipe } from '@shared/pipes/ellipsis.pipe';

@Component({
	selector: 'app-link-email',
	imports: [CommonModule, EllipsisPipe],
	templateUrl: './link-email.component.html',
	styleUrl: './link-email.component.scss',
})
export class LinkEmailComponent {
	@Input() email: string | null;
	@Input() maxCharacters: number = 50;

	get query(): string {
		return `mailto:${this.email}`;
	}
}
